export const USDT = 'USDT'
export const BNB = 'BNB'
